// BESTIE SCREENING ACTIVATE PACKAGE **************************************************************
// pathname: /v1/bestie-screening/activate-package
// ************************************************************************************************
import { useSwrMutationApi } from 'src/hooks/useSwrApi/useSwrMutationApi';
import type { ApiRequestBody, ApiOkResponse } from '@type/api/apiUtilityFn';

type ActivateRequestBody = ApiRequestBody<'/v1/bestie-screening/activate-package', 'post'>;
type ActivateResponse = ApiOkResponse<'/v1/bestie-screening/activate-package', 'post'>;

interface UseSwrBestieScreeningActivateProps {
  onSuccess?: (response: ActivateResponse) => void | Promise<void>;
  onError?: (err: unknown) => void;
}

/**
 * @description Hook for activating a bestie screening package via the main API proxy.
 * - `onSuccess`: Optional callback to execute on success.
 * - `onError`: Optional callback to execute on error.
 */
export const useSwrBestieScreeningActivate = (props?: UseSwrBestieScreeningActivateProps) => {
  const { onSuccess, onError } = props ?? {};

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ActivateResponse, ActivateRequestBody>({
    url: '/v1/bestie-screening/activate-package',
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
    apiOptions: {
      onSuccess: (response) => { if (onSuccess) { void onSuccess(response); } },
      onError: (err) => { if (onError) onError(err); },
    },
    toastsOptions: {
      showErrorToast: true,
      showSuccessToast: false,
    },
  });

  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
